import API from "APIs/base";
import { ENDPOINT } from "config/constants";

const createHoliday = async (data) => {
  // data: { date: "YYYY-MM-DD" }
  return await API.postMethod(ENDPOINT.holidays.create, true, data);
};

const getHolidays = async () => {
  return await API.getMethod(ENDPOINT.holidays.get, true);
};

const getHolidayByDate = async (date) => {
  return await API.getMethod(`${ENDPOINT.holidays.get}/${date}`, true);
};

const updateHolidayById = async (id, data) => {
  // PUT /holidays/:date  body: { date: "newDate" }
  return await API.putMethod(`${ENDPOINT.holidays.update}/${id}`, true, data);
};

const deleteHolidayById = async (id) => {
  return await API.deleteMethod(`${ENDPOINT.holidays.update}/${id}`, true);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  createHoliday,
  getHolidays,
  getHolidayByDate,
  updateHolidayById,
  deleteHolidayById,
};
